import{IconAsterisk100 as e}from"../src/elements/IconAsterisk100.js";customElements.define("sp-icon-asterisk100",e);
//# sourceMappingURL=sp-icon-asterisk100.js.map
